<template>
    <div class="p-5"><i class="fas fa-spinner fa-spin mr-2"></i>Please wait...</div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {client as http, axiosInstance} from "@/http_client";

    export default {
        methods: {
            ...mapActions(['loginRelay'])
        },
        mounted() {
            // Hold the token in a local: a 401 from the *previous* session's
            // in-flight requests can fire the global interceptor mid-relay,
            // which pushes the router to '/' and leaves $route.query empty by
            // the time /me resolves. Reading $route again down there stored the
            // string "undefined" as the token, so the tab worked until the next
            // refresh and then signed itself out.
            const token = this.$route.query.token;

            if (!token) {
                this.$router.push('/');
                return;
            }

            // Set token for /me call
            axiosInstance.defaults.headers.common['Authorization'] = token;

            http.get('/app/users/me', {force: true}).then(response => {
                // Set with all data
                this.loginRelay({...response.data, token});
                this.$router.push('/dashboard');
            }).catch(() => {
                this.$router.push('/');
            });
        }
    };
</script>

<style scoped>

</style>
